import Phaser from 'phaser';

export default class EmptyBlock extends Phaser.GameObjects.Container {

  constructor (scene, row, col, direction) {
    super(scene);


    this.name = 'EmptyBlock';
    this.row = row;
    this.column = col;
    this.direction = direction;
  };
}